<template>
  <v-card
    class="d-flex pa-2 flex-column align-center justify-center"
    outlined
    :style="{
      'margin-bottom': '40px',
      width: '80%',
      'min-height': '550px',
      height: 'fit-content',
    }"
    elevation="2"
  >
    <div
      class="d-flex flex-column justify-center align-center"
      :style="{
        'text-align': 'center',
        width: '70%',
        padding: '50px 0px 50px 0px',
      }"
    >
      <h2>Buat Akun</h2>
      <p>Akun ini digunakan untuk login ke aplikasi BNI QRIS</p>
      <form>
        <v-text-field
          v-model="email"
          :error-messages="emailErrors"
          label="E-mail"
          outlined
          @input="$v.email.$touch()"
          @blur="$v.email.$touch()"
          :disabled="loading"
        />
        <v-text-field
          v-model="mobilePhone"
          outlined
          :error-messages="mobilePhoneErrors"
          @change="$v.mobilePhone.$touch()"
          @blur="$v.mobilePhone.$touch()"
          label="Mobile Phone"
          :disabled="loading"
        />

        <v-progress-linear v-if="loading" :indeterminate="loading" />
        <br />
        <v-btn
          small
          color="warning"
          @click="prevStep"
          :style="{ margin: '2px' }"
          :disabled="loading"
        >
          <v-icon dark left> mdi-arrow-left </v-icon>Kembali
        </v-btn>
        <v-btn
          small
          color="primary"
          @click="nextStep"
          :style="{ margin: '2px' }"
          :disabled="loading"
        >
          Lanjut
          <v-icon dark right> mdi-arrow-right </v-icon>
        </v-btn>
      </form>
    </div>
  </v-card>
</template>

<script>
import { validationMixin } from 'vuelidate';
import {
  required,
  email,
  numeric,
  minLength,
  maxLength,
} from 'vuelidate/lib/validators';
import CustomEncryption from '../../lib/CustomEncryption';
import { dataExtraString3 } from '../../store/params';
import { date, regexDoesNotContainPipe } from '../../lib/helpers';

export default {
  name: 'step4',
  mixins: [validationMixin],
  validations: {
    email: {
      required,
      email,
      doesNotContainPipe: regexDoesNotContainPipe,
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.email == null ||
            this.errorValidation.email.length < 1)
        );
      },
    },
    mobilePhone: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(15),
      numeric,
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.mobile_phone == null ||
            this.errorValidation.mobile_phone.length < 1)
        );
      },
    },
    password: {},
    passwordConfirmation: {},
  },
  data() {
    return {
      email: '',
      mobilePhone: '',
      password: '',
      passwordConfirmation: '',
    };
  },
  watch: {
    email: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.email != null &&
            val != this.errorValidation.email
          ) {
            this.$store.commit('register/clearErrorVariable', 'email');
          }
        }
      },
    },
    mobilePhone: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.mobile_phone != null &&
            val != this.errorValidation.mobile_phone
          ) {
            this.$store.commit('register/clearErrorVariable', 'mobile_phone');
          }
        }
      },
    },
  },
  computed: {
    errorValidation() {
      return this.$store.state.register.errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.email || !this.$v.email.doesNotContainPipe)
        errors.push('Must be valid e-mail');
      if (!this.$v.email.required) errors.push('E-mail is required');
      if (!this.$v.email.isUnique) {
        if (this.errorValidation.email != null) {
          this.errorValidation.email.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      if (!this.$v.password.required) errors.push('Password is required');
      return errors;
    },
    mobilePhoneErrors() {
      const errors = [];
      if (!this.$v.mobilePhone.$dirty) return errors;
      if (!this.$v.mobilePhone.numeric) errors.push('Must be numeric');
      if (!this.$v.mobilePhone.required)
        errors.push('Mobile Phone is required');
      if (!this.$v.mobilePhone.minLength)
        errors.push(`Mobile Phone must be at least 8 characters long`);
      if (!this.$v.mobilePhone.maxLength)
        errors.push(`Mobile Phone can't more than 15 character`);
      if (!this.$v.mobilePhone.isUnique) {
        if (this.errorValidation.mobile_phone != null) {
          this.errorValidation.mobile_phone.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    passwordConfirmationErrors() {
      const errors = [];
      if (!this.$v.passwordConfirmation.$dirty) return errors;
      if (!this.$v.passwordConfirmation.required) {
        errors.push('Password is required');
      }
      if (!this.$v.passwordConfirmation.sameAsPassword) {
        errors.push('Passwords must be identical.');
      }
      return errors;
    },
    loading() {
      return this.$store.state.register.loading;
    },
  },
  methods: {
    prevStep() {
      this.$store.commit('register/setStep', 3);
    },
    nextStep() {
      this.$store.commit('register/clearErrors');
      this.$v.$touch();
      if (!this.$v.$invalid) {
        // eslint-disable-next-line new-cap
        const speEncrypt = new CustomEncryption();
        const extras = speEncrypt.decryption({
          enc: process.env.VUE_APP_STRING_EXTRA2,
          masterkey: dataExtraString3,
        });
        this.$store
          .dispatch('register/checkEmailPhone', {
            date,
            mobile_phone: this.mobilePhone,
            email: this.email,
          })
          .then((response) => {
            if (response) {
              const user = {
                email: this.email,
                mobilePhone: this.mobilePhone,
                password: speEncrypt.encrypt(
                  speEncrypt.encryption(this.password),
                  '',
                  extras
                ),
              };
              this.$store.commit('register/setUserData', user);
              this.$store.commit('register/setStep', 6);
            }
          });
      }
    },
  },
};
</script>
